import './footer.css'
import Fade from 'react-reveal/Fade';

const Footer = () => {
  return (
    <Fade>
    <footer >
      <div className='container footer-container'>
        <h4 className='footer-t'>Andy Opote</h4>
        <h6 className='footer-t'>© 2023</h6>
        </div>
    </footer>
    </Fade>
  )
}

export default Footer